const diacritics = {
    'ě': 'e', 'ť': 't', 'ů': 'u', 'í': 'i', 'ó': 'o', 'á': 'a', 'š': 's', 'ď': 'd', 'é': 'e', 'ž': 'z', 'ú': 'u', 'č': 'c', 'ň': 'n',
    'Ě': 'E', 'Ť': 'T', 'Ů': 'U', 'Í': 'I', 'Ó': 'O', 'Á': 'A', 'Š': 'S', 'Ď': 'D', 'É': 'E', 'Ž': 'Z', 'Ú': 'U', 'Č': 'C', 'Ň': 'N',
}

const alphanumericalCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const alphaCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

export const removeDiacritics = (str: string) => {
    return str.split('').map((char) => Object.keys(diacritics).includes(char) ? diacritics[char as keyof typeof diacritics] : char).join('');
};

export const removeAllNonAlphaNumCharacters = (str: string) => {
    return str.split('').filter(ch => alphanumericalCharacters.includes(ch)).join('');
};

export const removeAllNonAlphaCharacters = (str: string) => {
    return str.split('').filter(ch => alphaCharacters.includes(ch)).join('');

}